const DASHBOARD_ROUTES = {
  event_manager: '/home',
  manager: '/home',
  team_member: '/dashboard/tasks',
  staff: '/dashboard/tasks',
  hotel_manager: '/dashboard/rooms?tab=arrivals',
  bride: '/couple',
  groom: '/couple',
  host: '/host',
  admin_guest: '/guest',
  guest: '/guest',
};

export const getDashboardPath = (role) => DASHBOARD_ROUTES[role] || '/dashboard';

export const getAppEntryPath = ({ user, effectiveRole } = {}) => (
  user ? getDashboardPath(effectiveRole || user.role) : '/login'
);
